import { isValidPortalTemplateId } from '../theme/loginPortalThemes';
import { getSharedPageAtmosphere, setSharedPageAtmosphere } from './sharedPageAtmosphere';

const PANELS_KEY = 'erp4c_landing_panels_template';
const CAREER_KEY = 'erp4c_landing_career_template';
const FEATURES_KEY = 'erp4c_landing_features_template';
const NAV_KEY = 'erp4c_landing_nav_variant';

/** @typedef {'auto'|'light'|'dark'} LandingNavVariant */

function readTemplate(key) {
  try {
    const v = localStorage.getItem(key);
    if (isValidPortalTemplateId(v)) return v;
  } catch {
    /* ignore */
  }
  return null;
}

function writeTemplate(key, id) {
  try {
    const v = isValidPortalTemplateId(id) ? id : 'dark';
    localStorage.setItem(key, v);
  } catch {
    /* ignore */
  }
}

export function getStoredLandingPageTemplate() {
  return getSharedPageAtmosphere();
}

export function setStoredLandingPageTemplate(id) {
  setSharedPageAtmosphere(id);
}

export function getStoredLandingPanelsTemplate() {
  return readTemplate(PANELS_KEY) || getStoredLandingPageTemplate();
}

export function setStoredLandingPanelsTemplate(id) {
  writeTemplate(PANELS_KEY, id);
}

export function getStoredLandingCareerTemplate() {
  return readTemplate(CAREER_KEY) || getStoredLandingPageTemplate();
}

export function setStoredLandingCareerTemplate(id) {
  writeTemplate(CAREER_KEY, id);
}

export function getStoredLandingFeaturesTemplate() {
  return readTemplate(FEATURES_KEY) || getStoredLandingPageTemplate();
}

export function setStoredLandingFeaturesTemplate(id) {
  writeTemplate(FEATURES_KEY, id);
}

/** @returns {LandingNavVariant} */
export function getStoredLandingNavVariant() {
  try {
    const v = localStorage.getItem(NAV_KEY);
    if (v === 'light' || v === 'dark' || v === 'auto') return v;
  } catch {
    /* ignore */
  }
  return 'auto';
}

/** @param {LandingNavVariant} v */
export function setStoredLandingNavVariant(v) {
  try {
    localStorage.setItem(NAV_KEY, v === 'light' || v === 'dark' ? v : 'auto');
  } catch {
    /* ignore */
  }
}

/** Push landing page atmosphere to query portal + login (automatic via shared key). */
export function syncLandingPageTemplateToPortal(pageTemplateId) {
  setSharedPageAtmosphere(pageTemplateId);
}

export function resetLandingAppearanceToDefaults() {
  const def = 'light';
  setSharedPageAtmosphere(def);
  setStoredLandingPanelsTemplate(def);
  setStoredLandingCareerTemplate(def);
  setStoredLandingFeaturesTemplate(def);
  setStoredLandingNavVariant('auto');
}
